const skey = (key)=>`SAVED FORM: ${key}`

window.saveForms = function(key = location.pathname, storage = sessionStorage) {
  let values = {};
  for(let i = 0; i < document.forms.length; i++) {
    const fkey = `form${i}`
    values[fkey] = {}
    for(const el of document.forms[i].elements){
      if(!el.name || el.type=="hidden") continue;
      values[fkey][el.name] = el.value
    }
  }
  storage.setItem(skey(key), JSON.stringify(values));
}

window.loadForms = function(key = location.pathname) {
  const saved = sessionStorage.getItem(skey(key)) || localStorage.getItem(skey(key))
  if(!saved) return console.error(`Nothing saved for "${key}"`);
  const values = JSON.parse(saved);
  for(let i = 0; i < document.forms.length; i++) {
    const fkey = `form${i}`
    for(const el of document.forms[i].elements){
      if(!el.name || el.type=="hidden") continue;
      const found = values[fkey][el.name];
      if(found !== undefined) el.value = found;
    }
  }
}
